import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import { Platform } from '@modules/types/graphql';

import type { PlatformAccessItem, Lap } from '@modules/types/graphql';

export type Entity = Partial<PlatformAccessItem> | null;

@DecribeEntity('PlatformAccessItemEntity')
class PlatformAccessItemEntity extends BaseEntity {
    platform: Platform;
    isAvailable: boolean;
    lap?: Lap;

    constructor(lapAccess: Entity) {
        super(lapAccess);

        this.platform = lapAccess?.platform ?? Platform.online;
        this.isAvailable = lapAccess?.isAvailable ?? false;
        this.lap = lapAccess?.lap ?? undefined;
    }
}

export { PlatformAccessItemEntity };
